<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vini Savanha</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Celebrando tutto ciò che è bello e buono nella fiorente industria vinicola investibile sudafricana, i vini Savanha sono "un assaggio del sole sudafricano". Parte dell'organizzazione etica Speir, Savanha è impegnata nell'agricoltura sostenibile, offrendo opportunità professionali ai lavoratori svantaggiati che lavorano a fianco dell'enologo per le quattro denominazioni distintive di Savanha.
                    </div>

                    <div class="howto-title2">Super Smit</div>
                    <div class="howto-text">
                        L'enologo di tutti i vini Spier Frans Smit è responsabile di 5.400 tonnellate di uva all'anno. A titolo di ringraziamento per il suo impegno nei confronti del marchio - è stato con Spier per quasi 20 anni, nel 2004 ha rilasciato Frans K Smit, una miscela di 30% Merlot, 27% Cabernet Sauvignon, 19% Pinotage, 18% Shiraz e 6% Petit Verdot. Il vino boutique viene venduto attraverso il database Spier e raggiunge punti alti negli anni novanta, cosa che fa ben sperare per il resto di Spier e Stellenbosh in generale. L'expertise di Smit si trasmette a cascata attraverso i sette marchi (inclusi due bianchi frizzanti), rendendo Savana uno dei produttori più interessanti oggi sul mercato.
                    </div>

                    <div class="howto-title2">Quattro è il numero magico</div>
                    <div class="howto-text">
                        Dei quattro vini di Savanha - uno Chardonnay, uno Chenin Blanc, un Pinotage Rose e un Merlot, il Merlot è forse il meglio accolto dal mercato secondario. Mentre gli altri tre vini sono relativamente recenti con solo una o due annate, il Merlo di Savanha ha una prima annata del 1998 e può valere fino a 40 euro a bottiglia all'asta (a confronto, gli altri tre sono tutti sotto i 10-15 euro). È interessante notare che mentre il Merot è popolare in Francia, gli altri tre vini hanno raccolto un seguito di culto all'estero, in particolare in Cina.
                        <br><br>
                        Se questo produttore meriti il titolo di vino pregiato è troppo presto per dirlo. Tuttavia, con Smit al timone, crediamo che a Savanha stiano per accadere cose meravigliose.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Savanha-Weine</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Savanha-Weine sind eine Hommage an das Großartige und Gute an der aufstrebenden investierbaren Weinindustrie Südafrikas und „ein Vorgeschmack auf die südafrikanische Sonne“. Als Teil der ethischen Organisation Speir engagiert sich Savanha für eine nachhaltige Landwirtschaft und bietet benachteiligten Arbeitern, die mit den Winzern für Savanhas vier Signature-Appellationen zusammenarbeiten, berufliche Möglichkeiten.
                    </div>

                    <div class="howto-title2">Super Smit</div>
                    <div class="howto-text">
                        Der Winzer aller Spier-Weine, Frans Smit, ist für 5.400 Tonnen Trauben pro Jahr verantwortlich. Als Dank für sein Engagement für die Marke – er ist seit fast 20 Jahren bei Spier – veröffentlichte er 2004 Frans K Smit, eine Mischung aus 30 % Merlot, 27 % Cabernet Sauvignon, 19 % Pinotage, 18 % Shiraz und 6 % Petit Verdot. Der Boutique-Wein wird über die Spier-Datenbank verkauft und erreicht in den unteren Neunzigerjahren Spitzenwerte, was ein gutes Zeichen für den Rest von Spier und Stellenbosh im Allgemeinen ist. Das Fachwissen von Smit wird auf die sieben Marken (darunter zwei Schaumweine) übertragen und macht Savana heute zu einem der interessantesten Produzenten auf dem Markt.
                    </div>

                    <div class="howto-title2">Vier ist die magische Zahl</div>
                    <div class="howto-text">
                        Von den vier Weinen von Savanha – einem Chardonnay, einem Chenin Blanc, einem Pinotage Rose und einem Merlot – wird der Merlot vom Sekundärmarkt vielleicht am besten angenommen. Während die anderen drei Weine mit nur einem oder zwei Jahrgängen relativ neu sind, hat Savanha’s Merlo einen ersten Jahrgang von 1998 und kann bei einer Auktion bis zu 40 € pro Flasche erzielen (zum Vergleich: die anderen drei kosten alle weniger als 10–15 €). Es ist interessant festzustellen, dass der Merot zwar in Frankreich beliebt ist, die anderen drei Weine jedoch im Ausland, insbesondere in China, Kultstatus erlangt haben.
                        <br><br>
                        Ob dieser Produzent den Titel eines guten Weins verdient, lässt sich noch nicht sagen. Mit Smit an der Spitze glauben wir jedoch, dass bei Savanha wunderbare Dinge passieren werden.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vins de Savanha</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Célébrant tout ce qui est grand et bon dans l'industrie sud-africaine des vins fins en plein essor, les vins de Savanha sont "un avant-goût du soleil sud-africain". Membre de l'organisation éthique Speir, Savanha s'engage pour une agriculture durable, offrant des opportunités professionnelles aux travailleurs défavorisés qui travaillent aux côtés des vignerons pour les quatre appellations emblématiques de Savanha.
                    </div>

                    <div class="howto-title2">Super Smit</div>
                    <div class="howto-text">
                        Vigneron pour tous les vins Spier Frans Smit est responsable de 5 400 tonnes de raisins par an. En guise de remerciement pour son engagement envers la marque - il est chez Spier depuis près de 20 ans, en 2004 il a sorti Frans K Smit, un assemblage de 30% Merlot, 27% Cabernet Sauvignon, 19% Pinotage, 18% Shiraz et 6% Petit Verdot. Le vin boutique est vendu via la base de données Spier et atteint des sommets dans les années 90, ce qui est de bon augure pour le reste de Spier et de Stellenbosh en général. L'expertise de Smit se décline à travers les sept marques (dont deux blancs pétillants), faisant de Savana l'un des producteurs les plus intéressants du marché aujourd'hui.
                    </div>

                    <div class="howto-title2">Quatre est le nombre magique</div>
                    <div class="howto-text">
                        Des quatre vins de Savanha - un Chardonnay, un Chenin Blanc, un Pinotage Rose et un Merlot, le Merlot est peut-être le mieux accueilli par le marché secondaire. Alors que les trois autres vins sont relativement récents avec seulement un ou deux millésimes à leur nom, le Merlo de Savanha a un premier millésime de 1998 et peut atteindre jusqu'à 40 € la bouteille aux enchères (à titre de comparaison, les trois autres sont tous à moins de 10-15 €). Il est intéressant de noter que si le Merot est populaire en France, les trois autres vins ont acquis un culte à l'étranger, notamment en Chine.
                        <br><br>
                        Si ce producteur mérite le titre de bon vin, il est trop tôt pour le dire. Cependant, avec Smit à la barre, nous pensons que des choses merveilleuses sont sur le point de se produire à Savanha.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Savanha Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Celebrating all that is great and good about the burgeoning South African investable fine wine industry, Savanha wines are “a taste of the South African sunshine”. Part of the ethical organisation Speir, Savanha is committed to sustainable farming, offering professional opportunities to underprivileged workers who work alongside winemaker for Savanha’s four signature appelations.
                    </div>

                    <div class="howto-title2">Super Smit</div>
                    <div class="howto-text">
                        Winemaker for all Spier wines Frans Smit is reponsible for 5,400 tonnes of grapes a year. By way of thanks for his commitment to the brand - he has been with Spier for almost 20 years, in 2004 he released Frans K Smit, a blend of 30% Merlot, 27% Cabernet Sauvignon, 19% Pinotage, 18% Shiraz and 6% Petit Verdot. The boutique wine is sold through the Spier database and achieves high points in the low nineties, something which bodes well for the rest of Spier and Stellenbosh in general. Smit’s expertise is cascaded down through the seven brands (including two sparkling whites), making Savana one of the most intersting producers on the market today.
                    </div>

                    <div class="howto-title2">Four is the magic number</div>
                    <div class="howto-text">
                        Of Savanha’s four wines - a Chardonnay, a Chenin Blanc, a Pinotage Rose and a Merlot, the Merlot is perhaps the best received by the secondary market. While the other three wines are relatively recent with just one or two vintages to their name, Savanha’s Merlo has a first vintage of 1998 and can fetch up to €40 a bottle at auction (by comparision, the other three are all under €10-15). It is intersting to note that while the Merot is popular in France, the other three wines have gathered a cult following overseas, notably in China.
                        <br><br>
                        Whether this producer deserves the title of fine wine it is too early to say. However, with Smit at the helm, we believe that marvellous things are about to happen at Savanha.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SavanhaWines",
    data() {
        return {
            select: {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Savanha Wines | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich and diverse flavors of South Africa\'s wine culture with Savanha Wines. Experience the unique terroir of the region through our hand-crafted wines made with passion and expertise. Savor the taste of tradition and excellence with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
